module.exports = __webpack_public_path__ + "img/政策法规_1@2x.b1844ef9.png";